import React from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Container,
  Typography,
  Stack, // Changed from Grid
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

const PricingPage: React.FC = () => {
  const tiers = [
    {
      title: "Free Tier",
      price: "0",
      description: ["Register habit entries manually over a year"],
      buttonText: "Sign Up for Free",
      buttonVariant: "outlined" as "outlined" | "contained",
      linkTo: "/signup",
    },
    {
      title: "Plus Tier",
      price: "10",
      subheader: "per year",
      description: [
        "All Free Tier features",
        "View insightful graphics & track progress",
        "Set email reminders for your habits",
        "Receive personalized advice",
        "Exclusive members-only newsletter",
      ],
      buttonText: "Go Pro",
      buttonVariant: "contained" as "outlined" | "contained",
      linkTo: "/signup", // Placeholder, can be changed to a payment page later
    },
  ];

  return (
    <Container maxWidth="md" sx={{ mt: 8, mb: 8 }}>
      <Typography variant="h3" align="center" color="text.primary" gutterBottom>
        Choose Your Plan
      </Typography>
      <Typography
        variant="h6"
        align="center"
        color="text.secondary"
        component="p"
        sx={{ mb: 6 }}
      >
        Start tracking your habits today and unlock powerful features with our
        Pro plan.
      </Typography>
      <Stack
        direction={{ xs: "column", md: "row" }}
        spacing={5}
        alignItems="flex-end" // Or "stretch" for equal height cards
        justifyContent="center"
        sx={{ width: "100%" }}
      >
        {tiers.map((tier) => (
          <Box
            key={tier.title}
            sx={{
              width: { xs: "100%" }, // Takes full width on small screens
              flexGrow: { md: 1 }, // Grows to fill space on medium+ screens
              flexBasis: { md: 0 }, // Distributes space equally on medium+ screens
              minWidth: { md: "300px" }, // Optional: ensure cards have a minimum width
            }}
          >
            <Card
              sx={{ height: "100%", display: "flex", flexDirection: "column" }}
            >
              <CardHeader
                title={tier.title}
                subheader={tier.subheader}
                titleTypographyProps={{ align: "center" }}
                subheaderTypographyProps={{
                  align: "center",
                }}
                sx={{
                  backgroundColor: (theme) =>
                    theme.palette.mode === "light"
                      ? theme.palette.grey[200]
                      : theme.palette.grey[700],
                }}
              />
              <CardContent sx={{ flexGrow: 1 }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "baseline",
                    mb: 2,
                  }}
                >
                  <Typography component="h2" variant="h3" color="text.primary">
                    €{tier.price}
                  </Typography>
                  {tier.price !== "0" && tier.subheader && (
                    <Typography variant="h6" color="text.secondary">
                      &nbsp;/{tier.subheader.split(" ")[1]}
                    </Typography>
                  )}
                </Box>
                <List>
                  {tier.description.map((line) => (
                    <ListItem key={line} disableGutters>
                      <ListItemIcon sx={{ minWidth: "auto", mr: 1 }}>
                        <CheckIcon fontSize="small" color="success" />
                      </ListItemIcon>
                      <ListItemText primary={line} />
                    </ListItem>
                  ))}
                </List>
              </CardContent>
              <CardActions>
                <Button
                  fullWidth
                  variant={tier.buttonVariant}
                  component={RouterLink}
                  to={tier.linkTo}
                >
                  {tier.buttonText}
                </Button>
              </CardActions>
            </Card>
          </Box>
        ))}
      </Stack>
    </Container>
  );
};

export default PricingPage;
